import React, { PureComponent } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { SearchParams } from '../../bzit';
import BzitCountUsageImage, {
  getTypeFromKey
} from '../../bzit/BzitCountUsageImage';
import BzitLabel from '../../bzit/BzitLabel';
import { Column, Row } from '../../components/Grid';
import {
  BustypeRow,
  BustypeSelect,
  BustypeSelectRow,
  BustypeSelectWrapper,
  Description,
  DescriptionColumn,
  DescriptionName,
  DescriptionUsage
} from '../../components/Stage';
import { introSearchForm } from '../../configs/additionalSearchParams';
import { searchForm } from '../../configs/searchForm';
import { withErrorBoundary } from '../../error-handling/withErrorBoundary';
import { mkAdditionalSearchParams } from '../../provider/SearchProvider';
import {
  withSearch,
  WithSearchProps
} from '../../provider/SearchProvider/withSearch';
import { selectStage } from '../../provider/Typo3Provider/selectors';
import {
  withTypo3,
  WithTypo3Props
} from '../../provider/Typo3Provider/withTypo3';
import { Maybe } from '../../types';
import BustypeContent from './BustypeContent';
import BustypeCountAll from './BustypeCountAll';
import BustypeDoubleDecker, { DoubleDeckerKey } from './BustypeDoubleDecker';

export interface BustypeSelectContainerProps {
  header_link: string;
}

interface BustypeSelectContainerState {
  stage_items: any[];
}

const zeroUsages: { [key: string]: Maybe<number> } = {
  E01: 0,
  E02: 0,
  E03: 0,
  E09: 0
};

class BustypeSelectContainer extends PureComponent<
  BustypeSelectContainerProps &
    WithSearchProps &
    RouteComponentProps &
    WithTypo3Props,
  BustypeSelectContainerState
> {
  public state: BustypeSelectContainerState = {
    stage_items: selectStage(this.props.typo3)
  };

  public setSearchFormData = (props: Partial<SearchParams> = {}) => {
    const { search } = this.props;
    const { codeWheelpos, nameCurrency } = search.formParams;
    search.setSearchFormData({
      ...searchForm,
      ...{ codeWheelpos, nameCurrency },
      ...props
    });
  };

  public gotoSearch = () => {
    const { history, header_link, search } = this.props;
    // remove search value
    const additionalSearchParams = mkAdditionalSearchParams(introSearchForm);
    search.setAdditionalSearchParams(additionalSearchParams);
    history.push(header_link);
  };

  public onSelectSearchAll = () => {
    this.setSearchFormData();
    this.gotoSearch();
  };

  public onSelectSearchCodeUsage = (codeUsage: string) => {
    this.setSearchFormData({
      codeUsage
    });
    this.gotoSearch();
  };

  public onSelectSearchDoubleDecker = () => {
    this.setSearchFormData({
      codeBody: DoubleDeckerKey
    });
    this.gotoSearch();
  };

  public render() {
    const {
      search: {
        countUsage: { usages, bodies }
      }
    } = this.props;
    const { stage_items } = this.state;

    const normalizedUsages = {
      ...zeroUsages,
      ...usages
    };

    return (
      <BustypeSelectWrapper emptyStage={!stage_items.length}>
        <BustypeSelect>
          <Row noGap>
            <BustypeContent />

            <Column large={7} medium={12} small={12} bg="grayBg">
              <BustypeSelectRow>
                <BustypeCountAll
                  usages={normalizedUsages}
                  clickShowSearchResult={this.onSelectSearchAll}
                />

                {Object.keys(normalizedUsages).map(key => (
                  <Column medium={6} small={12} key={key}>
                    <BustypeRow
                      noGap
                      bg="white"
                      onClick={() => this.onSelectSearchCodeUsage(key)}
                    >
                      <Column small={6}>
                        <BzitCountUsageImage type={getTypeFromKey(key)} />
                      </Column>
                      <DescriptionColumn small={6}>
                        <Description>
                          <DescriptionUsage>
                            {normalizedUsages[key]}
                          </DescriptionUsage>
                          <DescriptionName>
                            <BzitLabel label={key} />
                          </DescriptionName>
                        </Description>
                      </DescriptionColumn>
                    </BustypeRow>
                  </Column>
                ))}
                <BustypeDoubleDecker
                  bodies={bodies}
                  clickShowSearchResult={this.onSelectSearchDoubleDecker}
                />
              </BustypeSelectRow>
            </Column>
          </Row>
        </BustypeSelect>
      </BustypeSelectWrapper>
    );
  }
}

export default withErrorBoundary(
  withRouter(withSearch(withTypo3(BustypeSelectContainer))),
  'BustypeSelectContainer'
);
